// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/manufacturing-orders',
        component: () =>
            import('@/pages/[organisation]/inventory/manufacturing-orders.vue'),
        name: 'inventory.manufacturing-orders.search-manufacturing-orders',
        meta: {
            loginRequired: true,
            permission: 'access.manufacturing.manufacturing-orders.view-manufacturing-orders',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/manufacturing-orders/new.vue'),
                name: 'inventory.manufacturing-orders.create-manufacturing-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.manufacturing-orders.create-manufacturing-order',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/manufacturing-orders/[id].vue'),
                name: 'inventory.manufacturing-orders.view-manufacturing-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.manufacturing-orders.view-manufacturing-orders',
                },
            },
        ],
    },
];
